// admin/src/services/api.js
import { REACT_APP_API_URL } from './host.js';
const API_BASE_URL = REACT_APP_API_URL;

class ApiService {
  // Utility method for making requests
  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    };

    if (config.body && typeof config.body === 'object') {
      config.body = JSON.stringify(config.body);
    }

    try {
      const response = await fetch(url, config);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'API request failed');
      }

      return data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  }

  // Rating History API
  async getRatings(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.request(`/ratings${queryString ? `?${queryString}` : ''}`);
  }

  async getRatingsByDateRange(startDay, endDay) {
    return this.request(`/ratings/date-range?startDay=${startDay}&endDay=${endDay}`);
  }

  async getCurrentMonthRatings() {
    return this.request('/ratings/current-month');
  }

  async createRating(ratingData) {
    return this.request('/ratings', {
      method: 'POST',
      body: ratingData,
    });
  }

  async deleteRatings(filter) {
    return this.request('/ratings', {
      method: 'DELETE',
      body: filter,
    });
  }

  // Staff API
  async getStaff(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.request(`/staff${queryString ? `?${queryString}` : ''}`);
  }

  async getStaffById(staffId) {
    return this.request(`/staff/${staffId}`);
  }

  async createStaff(staffData) {
    return this.request('/staff', {
      method: 'POST',
      body: staffData,
    });
  }

  async updateStaff(staffId, updateData) {
    return this.request(`/staff/${staffId}`, {
      method: 'PUT',
      body: updateData,
    });
  }

  async deleteStaff(filter) {
    return this.request('/staff', {
      method: 'DELETE',
      body: filter,
    });
  }

  // Users API
  async getUsers(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.request(`/users${queryString ? `?${queryString}` : ''}`);
  }

  async getUserById(userId) {
    return this.request(`/users/${userId}`);
  }

  async createUser(userData) {
    return this.request('/users', {
      method: 'POST',
      body: userData,
    });
  }

  // Statistics API
  async getStatistics() {
    return this.request('/statistics');
  }

  // Health check
  async healthCheck() {
    return this.request('/health');
  }

  // Authentication methods
  async authenticateAdmin(credentials) {
    return this.request('/users/login', {
      method: 'POST',
      body: credentials,
    });
  }

  // LoginUsers API (Admin management)
  async getLoginUsers(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.request(`/login-users${queryString ? `?${queryString}` : ''}`);
  }

  async getLoginUserById(userId) {
    return this.request(`/login-users/${userId}`);
  }

  async createLoginUser(userData) {
    return this.request('/login-users', {
      method: 'POST',
      body: userData,
    });
  }

  async updateLoginUser(userId, updateData) {
    return this.request(`/login-users/${userId}`, {
      method: 'PUT',
      body: updateData,
    });
  }

  async deleteLoginUser(userId) {
    return this.request(`/login-users/${userId}`, {
      method: 'DELETE',
    });
  }
}

const apiService = new ApiService();
export default apiService;